"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.functionCompletions = exports["default"] = void 0;

var _formulaEditor = require("@cimpress-technology/formula-editor");

var callRegex = /[_A-Za-z][_0-9A-Za-z]*(?=\s*\()/;
var identifierRegex = /[_A-Za-z][_0-9A-Za-z]*/;
var closeParenthesisRegex = /\)/;
var numberRegex = /[0-9]+(?:\.[0-9]+)?(?:[Ee][+-]?[0-9]{1,3})?/;
var operatorRegex = /(?:[-*/^%,[\]{}.:]|\+\+?|->?|[=!<>]=?)/;
var openParenthesisRegex = /\(/;
var variableRegex = /#{.*?}/;
var whitespaceRegex = /\s+/;

var _default = _formulaEditor.LanguageMode.create('rules').addHints('on-path').addDefaultState(function (state) {
  return state.addRule('number', numberRegex).addRule('identifier', variableRegex).addRule('call', callRegex).addRule('identifier', identifierRegex).addRule('operator', openParenthesisRegex, {
    indent: true
  }).addRule('operator', closeParenthesisRegex, {
    dedent: true
  }).addRule('operator', operatorRegex).addRule('whitespace', whitespaceRegex);
});

exports["default"] = _default;
var functionCompletions = [['clamp'], ['abs'], ['floor'], ['ceil'], ['round']];
exports.functionCompletions = functionCompletions;